module.exports = __webpack_public_path__ + "static/media/WhatIsATask.e1ae39ca.ipynb";